import { apiClient } from './api';
import { IntakeForm, IntakeReadResult } from '../types/intake';

/** 「프로젝트 추가」 접수 — 서버 `modules/intake` */
export const intakeApi = {
  /** 파일 · 글 → AI 가 채운 접수서. DB 에 쓰지 않는다(1~2분) */
  read(files: File[], text: string): Promise<IntakeReadResult> {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    form.append('text', text);
    return apiClient.postForm('/projects/intake/read', form);
  },
  /** 확인한 접수서 + 원본 → 검토 단계 프로젝트. 드라이브 · 첨부 실패는 warnings 로 온다 */
  create(intake: IntakeForm, files: File[]): Promise<{ id: number; warnings: string[] }> {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    form.append('form', JSON.stringify(intake));
    return apiClient.postForm('/projects/intake', form);
  },
  save(projectId: number, intake: IntakeForm): Promise<IntakeForm> {
    return apiClient.put(`/projects/${projectId}/intake`, intake);
  },
  /** 공고에서 담은 건 — 접수서가 없으면 공고 정보 · 요약으로 만든다(AI 안 씀) */
  fromBid(projectId: number): Promise<IntakeForm | null> {
    return apiClient.post(`/projects/${projectId}/intake/from-bid`);
  },
  /** 접수서 Word 를 드라이브 01 폴더에 새로 올린다 */
  docx(projectId: number): Promise<{ url: string }> {
    return apiClient.post(`/projects/${projectId}/intake/docx`);
  },
};
